export const theme = {
  colors: {
    primary: '#0071e3',
    secondary: '#0071e3',
    accent: '#5ac8fa',
    danger: '#ff3b30',
    success: '#34c759',
    warning: '#ff9f0a',

    background: '#ffffff',
    surface: '#ffffff',
    surfaceLight: '#f5f5f7',
    surfaceHover: '#e8e8ed',

    text: '#1d1d1f',
    textPrimary: '#1d1d1f',
    textSecondary: '#6e6e73',
    textTertiary: '#86868b',

    border: '#d2d2d7',
    borderBright: '#86868b',

    glow: 'rgba(0, 113, 227, 0.14)',
    glowPurple: 'rgba(94, 92, 230, 0.12)',
    glowCyan: 'rgba(90, 200, 250, 0.12)',

    terminal: {
      background: '#111820',
      blue: '#80b8e8',
      purple: '#c5a4ed',
      cyan: '#78c8c6',
      red: '#f18b85',
      yellow: '#e7c16f',
      green: '#81c995',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    sm: '0.5rem',
    md: '0.875rem',
    lg: '1.375rem',
    xl: '1.75rem',
  },
  shadows: {
    sm: '0 2px 8px rgba(0, 0, 0, 0.04)',
    md: '0 8px 24px rgba(0, 0, 0, 0.06)',
    lg: '0 18px 50px rgba(0, 0, 0, 0.08)',
    xl: '0 28px 70px rgba(0, 0, 0, 0.10)',
    glow: '0 10px 30px rgba(0, 113, 227, 0.14)',
    glowSm: '0 5px 16px rgba(0, 113, 227, 0.10)',
    glowLg: '0 20px 55px rgba(0, 113, 227, 0.16)',
    glowPurple: '0 10px 30px rgba(94, 92, 230, 0.12)',
    glowCyan: '0 10px 30px rgba(90, 200, 250, 0.12)',
  },
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
    bounce: 'cubic-bezier(0.22, 1, 0.36, 1)',
  },
  fonts: {
    mono: '"SFMono-Regular", "SF Mono", Menlo, Consolas, monospace',
    sans: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
    display: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", Arial, sans-serif',
  },
  effects: {
    scan: 'linear-gradient(90deg, transparent, rgba(31, 77, 122, 0.06), transparent)',
    noise: 'none',
  },
};

export type Theme = typeof theme;
